const isDev = typeof window !== 'undefined'
  ? ['localhost', '127.0.0.1'].includes(window.location.hostname)
  : false;

const buildScope = (scope: string, message: string) => `[${scope}] ${message}`;

export const logInfo = (scope: string, message: string, payload?: unknown) => {
  if (!isDev) return;
  if (payload !== undefined) {
    console.info(buildScope(scope, message), payload);
    return;
  }
  console.info(buildScope(scope, message));
};

export const logWarn = (scope: string, message: string, payload?: unknown) => {
  if (payload !== undefined) {
    console.warn(buildScope(scope, message), payload);
    return;
  }
  console.warn(buildScope(scope, message));
};

export const logError = (scope: string, message: string, payload?: unknown) => {
  if (payload !== undefined) {
    console.error(buildScope(scope, message), payload);
    return;
  }
  console.error(buildScope(scope, message));
};
